import BaseStore from 'hljd/esm/SearchBar/store'
import Api from '@api/zhiTuiBao'
import { Modal, message } from 'hljd'

const { confirm } = Modal

class Store extends BaseStore {
  $listApi = Api.flowPacketList

  constructor(pageStore) {
    super()
    this.pageStore = pageStore
  }

  activate = ({ id, use_days, title, product_id }) => async () => {
    confirm({
      title: `是否立即使用一个待激活的${title}，使用后会享受双倍流量以及推荐权重提升，被使用${title}有效期会从明日开始至${use_days}日后到期。`,
      okText: '确认',
      cancelText: '取消',
      onOk: () => {
        this.doActivate(id, product_id)
      }
    })
  }

  doActivate = async (id, product_id) => {
    const api =
      product_id == 230 || product_id == 234
        ? Api.ydtActivate
        : Api.activatePacket

    const { success } = await api({
      id
    })
    if (success) {
      message.success('激活成功')
      this.$getList()
      // 更新首页数据
      this.pageStore.getData()
    }
  }

  sureOrder = () => {
    alert('跳转确认下单')
  }
}

export default Store
